import React from 'react';
import { CreditCard, Shield, CheckCircle } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useApp } from '../../context/AppContext';

const BetaalmethodesPage = () => {
  const { t } = useApp();
  
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-2">{t('payment_methods_title')}</h1>
        <p className="text-[#A8A29E] mb-8">{t('payment_methods_subtitle')}</p>

        <div className="max-w-4xl space-y-8">
          {/* Payment Methods */}
          <div className="grid md:grid-cols-2 gap-6">
            {/* iDEAL */}
            <div className="glass rounded-xl p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-10 flex items-center justify-center rounded overflow-hidden">
                  <svg viewBox="0 0 60 40" className="w-full h-full">
                    <rect fill="#CC0066" width="60" height="40" rx="4"/>
                    <text x="30" y="26" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">iDEAL</text>
                  </svg>
                </div>
                <h2 className="font-heading text-xl text-white">iDEAL</h2>
              </div>
              <p className="text-[#A8A29E] text-sm">
                {t('ideal_desc')}
              </p>
            </div>

            {/* Mastercard */}
            <div className="glass rounded-xl p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-10 flex items-center justify-center rounded overflow-hidden">
                  <svg viewBox="0 0 60 40" className="w-full h-full">
                    <rect fill="#1A1F71" width="60" height="40" rx="4"/>
                    <circle cx="22" cy="20" r="10" fill="#EB001B"/>
                    <circle cx="38" cy="20" r="10" fill="#F79E1B"/>
                    <path d="M30 12c3 2.2 5 5.5 5 9s-2 6.8-5 9c-3-2.2-5-5.5-5-9s2-6.8 5-9z" fill="#FF5F00"/>
                  </svg>
                </div>
                <h2 className="font-heading text-xl text-white">Mastercard</h2>
              </div>
              <p className="text-[#A8A29E] text-sm">
                {t('mastercard_desc')}
              </p>
            </div>

            {/* Visa */}
            <div className="glass rounded-xl p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-10 flex items-center justify-center rounded overflow-hidden">
                  <svg viewBox="0 0 60 40" className="w-full h-full">
                    <rect fill="#1A1F71" width="60" height="40" rx="4"/>
                    <text x="30" y="26" textAnchor="middle" fill="white" fontSize="16" fontWeight="bold" fontStyle="italic">VISA</text>
                  </svg>
                </div>
                <h2 className="font-heading text-xl text-white">Visa</h2>
              </div>
              <p className="text-[#A8A29E] text-sm">
                {t('visa_desc')}
              </p>
            </div>

            {/* Apple Pay */}
            <div className="glass rounded-xl p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-10 flex items-center justify-center rounded overflow-hidden bg-black">
                  <svg viewBox="0 0 60 40" className="w-full h-full">
                    <rect fill="black" width="60" height="40" rx="4"/>
                    <text x="30" y="25" textAnchor="middle" fill="white" fontSize="12" fontWeight="500"> Pay</text>
                  </svg>
                </div>
                <h2 className="font-heading text-xl text-white">Apple Pay</h2>
              </div>
              <p className="text-[#A8A29E] text-sm">
                {t('applepay_desc')}
              </p>
            </div>
          </div>

          {/* Security */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <Shield size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('secure_payment')}</h2>
                <p className="text-[#A8A29E] mb-4">
                  {t('secure_payment_desc')}
                </p>
                <ul className="space-y-2 text-[#A8A29E]">
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    {t('ssl_encryption')}
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    {t('pci_certified')}
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    {t('3d_secure')}
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle size={16} className="text-green-500" />
                    {t('no_card_storage')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BetaalmethodesPage;
